
export class DateRangeDateSelector extends HTMLElement
{
    SELECT_NONE = -1;
    SELECT_START_DATE = 0;
    SELECT_END_DATE = 1;
    START_DATE_COLOR = '#276f28';
    END_DATE_COLOR = '#883333';
    DATE_RANGE_COLOR = '#777722';
    DATE_DISABLED_COLOR = '#aaa';

    constructor()
    {
        super();
    }

    get startDate()
    {
        const dateRangePicker = this.closest('date-range-picker');
        return dateRangePicker.startDate;
    }

    set startDate(startDate)
    {
        const dateRangePicker = this.closest('date-range-picker');
        dateRangePicker.startDate = startDate;
    }

    get endDate()
    {
        const dateRangePicker = this.closest('date-range-picker');
        return dateRangePicker.endDate;
    }

    set endDate(endDate)
    {
        const dateRangePicker = this.closest('date-range-picker');
        dateRangePicker.endDate = endDate;
    }

    get dateSelectionMode()
    {
           const dateRangePicker = this.closest('date-range-picker');
            return dateRangePicker.dateSelectionMode;
    }

    set dateSelectionMode(dateSelectionMode)
    {
        const dateRangePicker = this.closest('date-range-picker');
        dateRangePicker.dateSelectionMode = dateSelectionMode;
    }

    connectedCallback()
    {
        this.init();
    }

    init()
    {
        this.setStartEndDates();
        if (this.querySelector('div.calendars-header') == null) {
            this.appendChild(this.createCalendarsHeader());
        }
        this.highlightDateRange();
        this.initEventListeners();
    }

    setStartEndDates()
    {
        const dateRangeInput = document.querySelector('input[data-filter="ScheduledDate"]');
        console.assert(dateRangeInput !== null, 'DateRangeDateSelector: No input[filter="ScheduledDate"] found.');

        if (dateRangeInput.value !== '') {
            const dateRange = dateRangeInput.value.split('::');
            if (dateRange.length === 2) {
                this.startDate = new Date(dateRange[0]);
                this.endDate = new Date(dateRange[1]);
            } else {
                // last 60 days
                this.startDate = new Date();
                this.startDate.setDate(this.startDate.getDate() - 60);
                this.endDate = new Date();
            }
        } else {
            // last 60 days
            this.startDate = new Date();
            this.startDate.setDate(this.startDate.getDate() - 60);
            this.endDate = new Date();
        }

        const dateRangePicker = this.closest('date-range-picker');
        const calendarStartDateInput = dateRangePicker.querySelector('input#start-date-input');
        calendarStartDateInput.value = this.startDate.toISOString().split('T')[0];
        const calendarEndDateInput = dateRangePicker.querySelector('input#end-date-input');
        calendarEndDateInput.value = this.endDate.toISOString().split('T')[0];
    }

    highlightDateRange()
    {
        const startDate = this.startDate;
        const endDate = this.endDate;
        const calendarTables = this.querySelectorAll('table.calendar-table');
        calendarTables.forEach(calendarTable => {
            const calendarTableBodyCells = calendarTable.querySelectorAll('tbody td');
            calendarTableBodyCells.forEach(calendarTableBodyCell => {
                calendarTableBodyCell.style.backgroundColor = 'white';
                calendarTableBodyCell.style.color = calendarTableBodyCell.classList.contains('disabled') ? '#aaa' : 'black';
                const cellDate = new Date(calendarTableBodyCell.dataset.date);
                if (this.isValidDate(cellDate)) {
                    if (cellDate.toISOString().split('T')[0] > startDate.toISOString().split('T')[0] && cellDate.toISOString().split('T')[0] < endDate.toISOString().split('T')[0]) {
                        calendarTableBodyCell.style.backgroundColor = this.DATE_RANGE_COLOR;
                        calendarTableBodyCell.style.color = 'white';
                    } else if (cellDate.toISOString().split('T')[0] === startDate.toISOString().split('T')[0]) {
                        calendarTableBodyCell.style.backgroundColor = this.START_DATE_COLOR;
                        calendarTableBodyCell.style.color = 'white';
                    } else if (cellDate.toISOString().split('T')[0] === endDate.toISOString().split('T')[0]) {
                        calendarTableBodyCell.style.backgroundColor = this.END_DATE_COLOR;
                        calendarTableBodyCell.style.color = 'white';
                    }
                }
            });
        });
    }

    initEventListeners()
    {
        const nevButtons = this.querySelectorAll('button.calendar-nav-button');
        nevButtons.forEach(navButton => {
            navButton.addEventListener('click', this.onNavButtonClick.bind(this));
        });

    }

    onNavButtonClick(event)
    {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const navButton = event.target.closest('button.calendar-nav-button');
        if (navButton.classList.contains('disabled')) {
            return;
        }

        const calendarTablesWrapper = this.querySelector('div.calendar-table-wrapper-1');
        const currentCalendarDate = new Date(calendarTablesWrapper.dataset.calendarDate);

        let newCalendarDate = null;
        if (navButton.classList.contains('prev-year')) {
            newCalendarDate = new Date(currentCalendarDate.getFullYear() - 1, currentCalendarDate.getMonth(), 2);
        } else if (navButton.classList.contains('prev-month')) {
            newCalendarDate = new Date(currentCalendarDate.getFullYear(), currentCalendarDate.getMonth() - 1, 2);
        } else if (navButton.classList.contains('next-month')) {
            newCalendarDate = new Date(currentCalendarDate.getFullYear(), currentCalendarDate.getMonth() + 1, 2);
        } else if (navButton.classList.contains('next-year')) {
            newCalendarDate = new Date(currentCalendarDate.getFullYear() + 1, currentCalendarDate.getMonth(), 2);
        }

        this.appendChild(this.createDateCalendars(newCalendarDate));
        this.style.display = 'flex';
        this.highlightDateRange()
    }

    onSelectDate(event)
    {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (event.target.classList.contains('disabled')) {
            return;
        }

        const selectedDate = new Date(event.target.dataset.date + 'T00:00:00');
        const dateSelectionMode = this.dateSelectionMode;
        // check if user selecting an end date before the start date or a start date after the end date
        if ((dateSelectionMode === this.SELECT_START_DATE && this.endDate < selectedDate)
            || (dateSelectionMode === this.SELECT_END_DATE && this.startDate > selectedDate)) {
            return;
        }

        if (dateSelectionMode === this.SELECT_START_DATE) {
            this.startDate = selectedDate;
        } else if (dateSelectionMode === this.SELECT_END_DATE) {
            this.endDate = selectedDate;
        }

        this.highlightDateRange();

        const endDateInput = document.querySelector('input#end-date-input');
        if (dateSelectionMode === this.SELECT_START_DATE) {
            this.dateSelectionMode = this.SELECT_END_DATE;
            endDateInput.focus();
        } else if (dateSelectionMode === this.SELECT_END_DATE) {
            // hide calendars
            this.style.display = 'none';
            this.dateSelectionMode = this.SELECT_NONE;
        }


    }

    setDateRange(startDate, endDate)
    {
        this.startDate = startDate;
        this.endDate = endDate;
    }

    createCalendarsHeader()
    {
        const calendarsHeader = document.createElement('div');
        calendarsHeader.classList.add('calendars-header');
        const calendarHeaderLeft = document.createElement('div');
        calendarHeaderLeft.classList.add('calendar-header', 'calendar-header-left');
        const calendarHeaderCenter = document.createElement('div');
        calendarHeaderCenter.classList.add('calendar-header', 'calendar-header-center', 'calendar-header-selection-mode');
        calendarHeaderCenter.dataset.dateSelectionMode = `${this.SELECT_START_DATE}`;
        const calendarHeaderRight = document.createElement('div');
        calendarHeaderRight.classList.add('calendar-header', 'calendar-header-right');

        calendarHeaderLeft.appendChild(this.createCalendarButton('prev-year', 'outlined__fast_rewind', 'Previous Year', 'Year', 'right'));
        calendarHeaderLeft.appendChild(this.createCalendarButton('prev-month', 'outlined__play_arrow', 'Previous Month', 'Month', 'right'));
        calendarHeaderCenter.textContent = 'Select Begin Date';
        calendarHeaderRight.appendChild(this.createCalendarButton('next-month', 'outlined__play_arrow', 'Next Month', 'Month', 'left'));
        calendarHeaderRight.appendChild(this.createCalendarButton('next-year','outlined__fast_forward', 'Next Year', 'Year', 'left'));

        calendarsHeader.appendChild(calendarHeaderLeft);
        calendarsHeader.appendChild(calendarHeaderCenter);
        calendarsHeader.appendChild(calendarHeaderRight);


        return calendarsHeader;
    }


    updateNaveButtonStates(calendarTablesWrapper)
    {
        const currentDate = new Date();
        const calendarTablesWrapper2 = calendarTablesWrapper.querySelector('div.calendar-table-wrapper-2');
        const secondCalendarDate = new Date(calendarTablesWrapper2.dataset.calendarDate);
        let disabled = currentDate.getFullYear() === secondCalendarDate.getFullYear() && currentDate.getMonth() === secondCalendarDate.getMonth();
        const nextMonthButton = this.querySelector('button.calendar-nav-button.next-month');
        if (disabled) {
            nextMonthButton.classList.add('disabled');
        } else {
            nextMonthButton.classList.remove('disabled');
        }
        const nextYearCalendarDate = new Date(secondCalendarDate.getFullYear() + 1, secondCalendarDate.getMonth(), 2);
        disabled = nextYearCalendarDate.getFullYear() >= currentDate.getFullYear() && nextYearCalendarDate.getMonth() >= currentDate.getMonth();
        const nextYearButton = this.querySelector('button.calendar-nav-button.next-year');
        if (disabled) {
            nextYearButton.classList.add('disabled');
        } else {
            nextYearButton.classList.remove('disabled');
        }
    }

    createCalendarButton(className, icon, title, content, placement)
    {
        const calendarNavButton = document.createElement('button');
        calendarNavButton.classList.add('calendar-nav-button', className);
        calendarNavButton.style.foneSize = '12px';
        calendarNavButton.style.color = 'white';
        calendarNavButton.title = title;
        calendarNavButton.style.backgroundColor = '#367fa9';
        calendarNavButton.style.width = '70px';
        calendarNavButton.style.height = '22px';
        calendarNavButton.style.display = 'flex';
        calendarNavButton.style.flexDirection = 'row';
        calendarNavButton.style.justifyContent = 'space-around';
        calendarNavButton.style.alignItems = 'center';


        calendarNavButton.dataset.icon = icon;
        calendarNavButton.dataset.iconSize = '20px';
        calendarNavButton.dataset.iconColor = '#202085';

        const textSpan = document.createElement('span');
        textSpan.textContent = content;

        const svg = document.createElement('material-design-svg');
        svg.dataset.icon = icon;
        svg.dataset.iconSize = '20px';
        svg.dataset.iconColor = '#202085';

        if (['top', 'left'].includes(placement)) {
            textSpan.style.marginRight = '5px';
            calendarNavButton.appendChild(textSpan);
            calendarNavButton.appendChild(svg);
        } else {
            textSpan.style.marginLeft = '5px';
            calendarNavButton.appendChild(svg);
            calendarNavButton.appendChild(textSpan);
        }

        return calendarNavButton;
    }

    calculateDisplayedFirstCalendarDate()
    {
        const startDateInput = document.querySelector('input#start-date-input');
        const endDateInput = document.querySelector('input#end-date-input');
        const startDate = new Date(startDateInput.value);
        const endDate = new Date(endDateInput.value);
        const currentDate = new Date();
        if (endDateInput.dataset.active === 'true') {
            if (endDate.getMonth() === currentDate.getMonth() && endDate.getFullYear() === currentDate.getFullYear()) {
                return new Date(endDate.getFullYear(), endDate.getMonth() - 1, 2);
            } else {
                return new Date(endDate.getFullYear(), endDate.getMonth(), 2);
            }
        } else {
            if (startDate.getMonth() > currentDate.getMonth() && startDate.getFullYear() >= currentDate.getFullYear()) {
                return new Date(startDate.getFullYear(), startDate.getMonth() - 1, 2);
            } else {
                return new Date(startDate.getFullYear(), startDate.getMonth(), 2);
            }
        }
    }

    createDateCalendars(firstCalendarStartDate = null)
    {
        if (firstCalendarStartDate === null) {
            firstCalendarStartDate = this.calculateDisplayedFirstCalendarDate();
        }
        const $secondCalendarEndDate = new Date(firstCalendarStartDate.getFullYear(), firstCalendarStartDate.getMonth() + 1, 2);
        let calendarTablesWrapper = this.querySelector('div.calendar-tables-wrapper');
        if (calendarTablesWrapper !== null) {
            calendarTablesWrapper.remove();
        }

        calendarTablesWrapper = document.createElement('div');
        calendarTablesWrapper.classList.add('calendar-tables-wrapper');

        const calendarTableWrapper1 = document.createElement('div');
        calendarTableWrapper1.classList.add('calendar-table-wrapper', 'calendar-table-wrapper-1');
        calendarTableWrapper1.dataset.calendarDate = firstCalendarStartDate.toISOString().split('T')[0];
        calendarTableWrapper1.appendChild(this.createCalendarHeader(firstCalendarStartDate));
        calendarTableWrapper1.appendChild(this.createCalendarTable(firstCalendarStartDate));
        calendarTablesWrapper.appendChild(calendarTableWrapper1);
        let tableBody = calendarTableWrapper1.querySelector('table.calendar-table tbody');
        tableBody.addEventListener('click', this.onSelectDate.bind(this));

        const calendarTableWrapper2 = document.createElement('div');
        calendarTableWrapper2.classList.add('calendar-table-wrapper', 'calendar-table-wrapper-2');
        calendarTableWrapper2.dataset.calendarDate = $secondCalendarEndDate.toISOString().split('T')[0];
        calendarTableWrapper2.appendChild(this.createCalendarHeader($secondCalendarEndDate));
        calendarTableWrapper2.appendChild(this.createCalendarTable($secondCalendarEndDate));
        calendarTablesWrapper.appendChild(calendarTableWrapper2);
        tableBody = calendarTableWrapper2.querySelector('table.calendar-table tbody');
        tableBody.addEventListener('click', this.onSelectDate.bind(this));

        // set a window listener to close the calendar if the user clicks outside of the calendar
        window.addEventListener('click', (event) => {
            if (!event.target.closest('.calendar-table tbody')
                && !event.target.classList.contains('start-date-input')
                && !event.target.classList.contains('end-date-input')
                && !event.target.classList.contains('start-date-input')) {
                this.style.display = 'none';
            }
        });

        this.highlightDateRange();
        this.updateNaveButtonStates(calendarTablesWrapper);

        return calendarTablesWrapper;
    }

    createCalendarHeader(date)
    {
        const dateRangeSelectorHeader = document.createElement('div');
        dateRangeSelectorHeader.classList.add('date-range-selector-header');

        const currentMonth = date.toLocaleString('default', { month: 'long' });
        const currentYear = date.getFullYear();
        const monthYearSpan = document.createElement('span');
        monthYearSpan.classList.add('month-year-span');
        monthYearSpan.textContent = currentMonth + ', ' + currentYear;
        dateRangeSelectorHeader.appendChild(monthYearSpan);


        return dateRangeSelectorHeader;
    }

    createCalendarTable(date)
    {
        const calendarTable = document.createElement('table');
        calendarTable.classList.add('calendar-table');

        const calendarTableHead = document.createElement('thead');
        const calendarTableHeadRow = document.createElement('tr');
        const daysOfWeek = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
        daysOfWeek.forEach(day => {
            const dayOfWeek = document.createElement('th');
            dayOfWeek.setAttribute('scope', 'col');
            dayOfWeek.setAttribute('abbr', day);
            dayOfWeek.textContent = day;
            calendarTableHeadRow.appendChild(dayOfWeek);
        });
        calendarTableHead.appendChild(calendarTableHeadRow);
        calendarTable.appendChild(calendarTableHead);

        const currentDate = new Date();
        const calendarTableBody = document.createElement('tbody');
        const daysOfMonth = this.getDaysOfMonth(date.getMonth(), date.getFullYear());
        let dayCount = 0;
        for (let i = 0; i < 6; i++) {
            const calendarTableBodyRow = document.createElement('tr');
            for (let j = 0; j < 7; j++) {
                const dayDate = new Date(daysOfMonth[dayCount]);
                const calendarTableBodyCell = document.createElement('td');
                if (i === 0 && j < daysOfMonth[0].getDay()) {
                    calendarTableBodyCell.classList.add('disabled');
                } else if (dayCount >= daysOfMonth.length) {
                    calendarTableBodyCell.classList.add('disabled');
                } else if (dayDate > currentDate) {
                    calendarTableBodyCell.classList.add('disabled');
                    calendarTableBodyCell.textContent = daysOfMonth[dayCount].getDate();
                    dayCount++;
                } else {
                    calendarTableBodyCell.setAttribute('tabindex', '-1');
                    calendarTableBodyCell.setAttribute('data-date', daysOfMonth[dayCount].toISOString().split('T')[0]);
                    calendarTableBodyCell.textContent = daysOfMonth[dayCount].getDate();
                    dayCount++;
                }
                calendarTableBodyRow.appendChild(calendarTableBodyCell);
            }
            calendarTableBody.appendChild(calendarTableBodyRow);
        }

        calendarTable.appendChild(calendarTableBody);
        return calendarTable;
    }

    getDaysOfMonth(month, year)
    {
        const daysOfMonth = [];
        const date = new Date(year, month, 1);
        while (date.getMonth() === month) {
            daysOfMonth.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }
        return daysOfMonth;
    }

    createSvgElement(svg)
    {
        const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" ' +
            'width="50" ' +
            'height="30" ' +
            'viewBox="0 0 560 560" ' +
            'fill="none">' +
            '<rect ' +
            'width="300" ' +
            'height="100" ' +
            'rx="28" ' +
            'fill="none"></rect>' +
            '<path d="' + svg[4] + '" ' +
            'stroke="red" ' +
            'stroke-width="2.5" ' +
            'stroke-linecap="round" ' +
            'stroke-linejoin="round" ' +
            'fill="red"></path></svg>';

        const parser = new DOMParser();
        return parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;
    }

    isValidDate(d)
    {
        return d instanceof Date && !isNaN(d);
    }
}

customElements.define('date-range-date-selector', DateRangeDateSelector);